import React, { useContext } from "react";
import { ViewStateInspectionPopup } from "@/modern/components/editors/viewStateInspectionPopup/ViewStateInspectionPopup";
import { Button } from "@/modern/components/ui/button";
import { Pencil } from "lucide-react";
import useViews from "../../../../hooks/useViews.jsx";
import BryntumContext from "../../../../context/bryntumContext.jsx";
import { EDITOR_KEYS } from "../../../../../other/constants/EditorKeys.jsx";
import { canSaveView } from "../../../../../other/utils/utils.jsx";
import { useSwivuStore } from "@/react/hooks/useSwivuStore";
import { STORE_KEYS } from "@/other/constants/StoreKeys.jsx";
import { PERSISTENCE_STATE_KEYS } from "@/other/constants/PersistenceStateKeys.jsx";

const AppViewStateInspectButton = () => {
  const context = useContext(BryntumContext);
  const { editorHandler } = context;
  const viewManagerState = useViews();

  // Subscribe to PIITS changes
  useSwivuStore({
    storeId: STORE_KEYS.userPreferencesStore,
    subscriberFn: ({ record: changedRecord }) => changedRecord?.key === PERSISTENCE_STATE_KEYS.viewStatePIITS
  });

  const isVisible = viewManagerState?.selectedView?.hasPIITS;

  const handleClick = () => {
    if (canSaveView(viewManagerState?.selectedView.viewType)) {
      editorHandler.openEditor(EDITOR_KEYS.viewInspectorEditor, null, { viewRecord: viewManagerState.selectedView }, { by: "recordType", useExisting: true });
    }
  };

  if (!isVisible) return null;

  return (
    <div className="w-2">
      <ViewStateInspectionPopup
        viewRecord={viewManagerState?.selectedView}
        context={context}
      >
        <Button
          variant="ghost"
          size="icon"
          className="absolute right-3 -top-2 h-4 w-4 p-0 hover:bg-transparent text-amber-700 dark:text-amber-600 z-10 translate-x-full -translate-y-1"
          onClick={handleClick}
        >
          <Pencil className="h-3 w-3" />
        </Button>
      </ViewStateInspectionPopup>
    </div>
  );
};

export default AppViewStateInspectButton;
